export type SupportTicketCategory = 'tecnico' | 'curso' | 'administrativo';
export type SupportTicketStatus = 'abierto' | 'en_progreso' | 'resuelto' | 'cerrado';
export type SupportTicketPriority = 'baja' | 'normal' | 'alta';

export interface SupportUserSummary {
  id: string;
  name: string;
  email: string;
}

export interface SupportCourseSummary {
  id: string;
  name: string;
}

export interface SupportMessage {
  id: string;
  body: string;
  isInternal: boolean;
  createdAt: string;
  author: SupportUserSummary;
}

export interface SupportTicket {
  id: string;
  number: number;
  subject: string;
  category: SupportTicketCategory;
  categoryLabel: string;
  status: SupportTicketStatus;
  statusLabel: string;
  priority: SupportTicketPriority;
  priorityLabel: string;
  createdAt: string;
  updatedAt: string;
  closedAt: string | null;
  user: SupportUserSummary;
  assignee: SupportUserSummary | null;
  course: SupportCourseSummary | null;
  messages?: SupportMessage[];
}

export const CATEGORY_LABELS: Record<SupportTicketCategory, string> = {
  tecnico: 'Soporte técnico',
  curso: 'Consulta de curso',
  administrativo: 'Administrativo',
};

export const STATUS_LABELS: Record<SupportTicketStatus, string> = {
  abierto: 'Abierto',
  en_progreso: 'En progreso',
  resuelto: 'Resuelto',
  cerrado: 'Cerrado',
};

export const PRIORITY_LABELS: Record<SupportTicketPriority, string> = {
  baja: 'Baja',
  normal: 'Normal',
  alta: 'Alta',
};

export function statusBadgeClass(status: SupportTicketStatus): string {
  if (status === 'abierto') return 'support-badge support-badge--open';
  if (status === 'en_progreso') return 'support-badge support-badge--progress';
  if (status === 'resuelto') return 'support-badge support-badge--resolved';
  return 'support-badge support-badge--closed';
}

export function statusBadgeAdminClass(status: SupportTicketStatus): string {
  if (status === 'abierto') return 'support-admin-status support-admin-status--open';
  if (status === 'en_progreso') return 'support-admin-status support-admin-status--progress';
  if (status === 'resuelto') return 'support-admin-status support-admin-status--resolved';
  return 'support-admin-status support-admin-status--closed';
}

export function priorityAdminClass(priority: SupportTicketPriority): string {
  if (priority === 'alta') return 'support-admin-priority support-admin-priority--high';
  return 'support-admin-priority';
}

export function statusBadgeHeaderClass(_status: SupportTicketStatus): string {
  return 'support-admin-ticket-status-badge';
}
